import { DWSlateEditor } from 'src/components/slate-editor';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWSlateEditor.displayName, DWSlateEditor);

export default DWSlateEditor;
export { DWSlateEditor };
